import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, TrendingUp, ChevronRight, X } from 'lucide-react';
interface DashboardProps {
  userRole: 'Program Manager' | 'Founder';
}
const Dashboard: React.FC<DashboardProps> = ({
  userRole
}) => {
  const [showModal, setShowModal] = useState(false);
  const [nudgeSent, setNudgeSent] = useState(false);
  const handleRequestAction = () => {
    setShowModal(true);
  };
  const handleSendNudge = () => {
    setNudgeSent(true);
    setTimeout(() => {
      setShowModal(false);
    }, 500);
  };
  return <div className="w-full px-6 pt-6" data-id="element-529">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-530">
        Eshelman Innovation Kairos Program
      </h1>
      {/* KPI Tiles */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-531">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-532">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-533">
            Ventures by Stage
          </h3>
          <div className="flex items-end justify-between" data-id="element-534">
            <div className="flex space-x-3" data-id="element-535">
              <div data-id="element-536">
                <span className="text-xl font-semibold text-gray-800" data-id="element-537">3</span>
                <p className="text-xs text-gray-500" data-id="element-538">Problem</p>
              </div>
              <div data-id="element-539">
                <span className="text-xl font-semibold text-gray-800" data-id="element-540">2</span>
                <p className="text-xs text-gray-500" data-id="element-541">Position</p>
              </div>
              <div data-id="element-542">
                <span className="text-xl font-semibold text-gray-800" data-id="element-543">1</span>
                <p className="text-xs text-gray-500" data-id="element-544">Pilot</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-545">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-546">
            Insights This Week
          </h3>
          <div className="flex items-end justify-between" data-id="element-547">
            <span className="text-xl font-semibold text-grey-800" data-id="element-548">92</span>
            <span className="text-xs py-1 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-549">
              153%
            </span>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-550">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-551">Agent Hours</h3>
          <div className="flex items-end justify-between" data-id="element-552">
            <span className="text-xl font-semibold text-gray-800" data-id="element-553">12</span>
            <span className="text-xs py-1 px-2 bg-green-100 text-green-800 rounded-full flex items-center" data-id="element-554">
              <TrendingUp size={12} className="mr-1" data-id="element-555" /> 3 vs last week
            </span>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-556">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-557">Risk Flags</h3>
          <div className="flex items-end justify-between" data-id="element-558">
            <div className="flex space-x-2" data-id="element-559">
              <div data-id="element-560">
                <span className="text-xl font-semibold text-red-600" data-id="element-561">1</span>
                <p className="text-xs text-gray-500" data-id="element-562">Red</p>
              </div>
              <div data-id="element-563">
                <span className="text-xl font-semibold text-yellow-600" data-id="element-564">1</span>
                <p className="text-xs text-gray-500" data-id="element-565">Amber</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-566">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-567">
            Monthly Credits
          </h3>
          <div className="flex flex-col" data-id="element-568">
            <span className="text-xl font-semibold text-gray-800 flex items-baseline" data-id="element-569">
              720 / 1,000<span className="text-sm text-gray-400 ml-1" data-id="element-570">M</span>
            </span>
            <div className="w-full h-1.5 bg-gray-200 rounded-full mt-2" data-id="element-571">
              <div className="w-[72%] h-1.5 bg-blue-500 rounded-full" data-id="element-572"></div>
            </div>
          </div>
        </div>
      </div>
      {/* Current Ventures */}
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-573">
        Current Ventures
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-574">
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-575">
          <div className="flex items-center justify-between mb-2" data-id="element-576">
            <h3 className="font-medium text-gray-800" data-id="element-577">CardioSense</h3>
            <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-578">
              Problem
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-579">Cardiac rehab adherence</p>
          <div className="flex justify-between items-center" data-id="element-580">
            <div className="text-xs text-gray-500" data-id="element-581">Last update: 2 days ago</div>
            <Link to="/ventures/cardiosense" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-582">
              View venture →
            </Link>
          </div>
        </div>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-583">
          <div className="flex items-center justify-between mb-2" data-id="element-584">
            <h3 className="font-medium text-gray-800" data-id="element-585">MedBridge AI</h3>
            <span className="px-2 py-0.5 text-xs bg-purple-100 text-purple-800 rounded-full" data-id="element-586">
              Position
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-587">Clinical trial matching</p>
          <div className="flex justify-between items-center" data-id="element-588">
            <div className="text-xs text-gray-500" data-id="element-589">Last update: Yesterday</div>
            <Link to="/ventures/medbridge" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-590">
              View venture →
            </Link>
          </div>
        </div>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-591">
          <div className="flex items-center justify-between mb-2" data-id="element-592">
            <h3 className="font-medium text-gray-800" data-id="element-593">NeuroNote</h3>
            <span className="px-2 py-0.5 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-594">
              Pilot
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-595">EHR documentation</p>
          <div className="flex justify-between items-center" data-id="element-596">
            <div className="text-xs text-gray-500" data-id="element-597">Last update: Today</div>
            <Link to="/ventures/neuronote" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-598">
              View venture →
            </Link>
          </div>
        </div>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-599">
          <div className="flex items-center justify-between mb-2" data-id="element-600">
            <h3 className="font-medium text-gray-800" data-id="element-601">PharmaFlow</h3>
            <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-602">
              Problem
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-603">Pharmacy workflow</p>
          <div className="flex justify-between items-center" data-id="element-604">
            <div className="text-xs text-gray-500" data-id="element-605">Last update: 5 days ago</div>
            <Link to="/ventures/pharmaflow" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-606">
              View venture →
            </Link>
          </div>
        </div>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-607">
          <div className="flex items-center justify-between mb-2" data-id="element-608">
            <h3 className="font-medium text-gray-800" data-id="element-609">VitalSync</h3>
            <span className="px-2 py-0.5 text-xs bg-purple-100 text-purple-800 rounded-full" data-id="element-610">
              Position
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-611">
            Remote patient monitoring
          </p>
          <div className="flex justify-between items-center" data-id="element-612">
            <div className="text-xs text-gray-500" data-id="element-613">Last update: 1 week ago</div>
            <Link to="/ventures/vitalsync" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-614">
              View venture →
            </Link>
          </div>
        </div>
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-615">
          <div className="flex items-center justify-between mb-2" data-id="element-616">
            <h3 className="font-medium text-gray-800" data-id="element-617">CareConnect</h3>
            <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-618">
              Problem
            </span>
          </div>
          <p className="text-sm text-gray-500 mb-3" data-id="element-619">Care coordination</p>
          <div className="flex justify-between items-center" data-id="element-620">
            <div className="text-xs text-gray-500" data-id="element-621">Last update: 3 days ago</div>
            <Link to="/ventures/careconnect" className="text-xs text-blue-600 hover:text-blue-800" data-id="element-622">
              View venture →
            </Link>
          </div>
        </div>
      </div>
      {/* Risk List */}
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-623">Risk Flags</h2>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-624">
        <div className="p-4 border-b border-gray-200 flex items-center gap-2" data-id="element-625">
          <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-626"></div>
          <h3 className="font-medium text-gray-800 flex-1" data-id="element-627">CardioSense</h3>
          <span className="px-3 py-1 text-xs bg-red-100 text-red-800 rounded-full mr-4" data-id="element-628">
            Red
          </span>
          <p className="text-sm text-gray-600 flex-1" data-id="element-629">
            Insufficient validated problem interviews (0 in last 14 days; 2
            insights published total).
          </p>
          <div className="flex space-x-2" data-id="element-630">
            <Link to="/ventures/cardiosense" className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-631">
              Open venture
            </Link>
            <button onClick={handleRequestAction} className="px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-632">
              Request action
            </button>
          </div>
        </div>
        <div className="p-4 flex items-center gap-2" data-id="element-633">
          <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-634"></div>
          <h3 className="font-medium text-gray-800 flex-1" data-id="element-635">NeuroNote</h3>
          <span className="px-3 py-1 text-xs bg-yellow-100 text-yellow-800 rounded-full mr-4" data-id="element-636">
            Amber
          </span>
          <p className="text-sm text-gray-600 flex-1" data-id="element-637">
            Approaching credit limit (85% used).
          </p>
          <div className="flex space-x-2" data-id="element-638">
            <button className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-639">
              Open venture
            </button>
            <button className="px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-640">
              Request action
            </button>
          </div>
        </div>
      </div>
      {/* Nudge Success Message */}
      {nudgeSent && <div className="fixed bottom-4 right-4 bg-green-100 border border-green-200 text-green-800 px-4 py-3 rounded-lg shadow-md flex items-center" data-id="element-641">
          <span data-id="element-642">Nudge sent to CardioSense team</span>
          <button onClick={() => setNudgeSent(false)} className="ml-3 p-1 hover:bg-green-200 rounded-full" data-id="element-643">
            <X size={16} data-id="element-644" />
          </button>
        </div>}
      {/* Request Action Modal */}
      {showModal && <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-645">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-646">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-647">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-648">
                Recommend next step to CardioSense
              </h2>
              <button onClick={() => setShowModal(false)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-649">
                <X size={20} className="text-gray-500" data-id="element-650" />
              </button>
            </div>
            <div className="p-4" data-id="element-651">
              <div className="mb-4" data-id="element-652">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-653">
                  Suggested Agent
                </label>
                <div className="flex items-center p-3 border border-gray-300 rounded-md bg-gray-50" data-id="element-654">
                  <span className="text-gray-800" data-id="element-655">
                    Customer Interview Transcript Analyst
                  </span>
                  <ChevronRight size={16} className="ml-auto text-gray-400" data-id="element-656" />
                </div>
              </div>
              <div className="mb-4" data-id="element-657">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-658">
                  Note to Team
                </label>
                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" rows={3} defaultValue="Please run the Transcript Analyst on your latest nurse manager interview and publish the top 3 insights with citations." data-id="element-659" />
              </div>
            </div>
            <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-660">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md mr-2 transition-colors" data-id="element-661">
                Cancel
              </button>
              <button onClick={handleSendNudge} className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-662">
                Send nudge
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default Dashboard;